<template>
  <section class="contest-grid">
    <div class="inner-section">
      <h2>Les participations</h2>
      <p
        v-if="!posts.length"
        class="no-content"
      >
        Aucune participation pour le moment
      </p>
      <div
        v-else
        class="grid"
        :class="[contestType === 1 ? 'grid-image' : 'grid-video']"
      >
        <div
          v-for="item in posts"
          :key="item.slug"
          class="item"
        >
          <div class="content">
            <template v-if="contestType === 1">
              <div
                class="img"
                @click="fetchPost(item.slug)"
              >
                <img
                  :src="item.image?.url"
                  loading="lazy"
                />
              </div>
            </template>
            <template v-else>
              <div class="iframe">
                <lite-youtube
                  v-if="getVideoInfo(item.video).isYoutube"
                  class="iframe-placeholder"
                  :videoid="getVideoInfo(item.video).cover"
                  playlabel="Afficher la vidéo"
                />
                <iframe
                  v-else
                  :src="getVideoInfo(item.video).cover"
                  frameborder="0"
                  class="p-video__iframe"
                />
                <div
                  class="layer"
                  @click="fetchPost(item.slug)"
                />
              </div>
            </template>
            <div class="infos">
              <div
                class="waper"
                @click="fetchPost(item.slug)"
              >
                <NuxtImg
                  :src="item.user?.avatar?.url"
                  class="p-waper__avatar"
                  loading="lazy"
                  quality="80"
                  width="42"
                  height="42"
                  sizes="sm:42px tb:84px"
                  fit="cover"
                  format="auto"
                />
                <p class="p-waper__nickname">
                  {{ item.user?.nickname }}
                </p>
              </div>
              <div class="stats">
                <div
                  class="like"
                  :class="{ is_liked: item.is_liked }"
                  @click="tryLike(item)"
                >
                  {{ kFormatter(item.likes_count) }}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.804"
                    height="15.731"
                    viewBox="0 0 17.804 15.731"
                  >
                    <path
                      d="M17.804 7.615a2.188 2.188 0 0 1-.109.333c-.1.2-.219.383-.323.578a.247.247 0 0 0-.039.178 1.765 1.765 0 0 1-.292 1.8.193.193 0 0 0-.041.218 1.727 1.727 0 0 1-.232 1.683.422.422 0 0 0-.084.387 1.888 1.888 0 0 1-.446 1.853 1.635 1.635 0 0 1-.892.474 5.151 5.151 0 0 1-.915.1H7.655a2.075 2.075 0 0 1-1.143-.373.428.428 0 0 0-.339-.086 2.441 2.441 0 0 1-.027.326.713.713 0 0 1-.654.64 1.408 1.408 0 0 1-.155 0H.827a.763.763 0 0 1-.823-.7V7.928a.795.795 0 0 1 .835-.845h5.088a2.851 2.851 0 0 1 .357.068.243.243 0 0 0 .178-.021 5.533 5.533 0 0 0 .519-.58 23.722 23.722 0 0 0 1.851-3.04 1.1 1.1 0 0 0 .134-.569c-.023-.587-.023-1.176-.047-1.762a.974.974 0 0 1 .515-.927 1.9 1.9 0 0 1 2.063.114 1.176 1.176 0 0 1 .322.475c.219.535.428 1.082.613 1.633a3.532 3.532 0 0 1 .075 1.851c-.093.469-.16.943-.241 1.414-.027.16-.021.178.143.178h3.854a1.649 1.649 0 0 1 .892.212 1.347 1.347 0 0 1 .594.849c.014.055.032.109.048.162v.483Zm-6.457-.963c.139-.826.28-1.633.408-2.441a3.594 3.594 0 0 0 .08-.87 7.146 7.146 0 0 0-.7-2.2.535.535 0 0 0-.4-.357 1.206 1.206 0 0 0-.892.078.319.319 0 0 0-.194.325q.036.974.036 1.947a1.325 1.325 0 0 1-.077.455 3.122 3.122 0 0 1-.26.535c-.535.876-1.07 1.755-1.619 2.62a3.355 3.355 0 0 1-.958 1.07c-.253.164-.508.332-.754.5a.242.242 0 0 0-.1.164v5.289c0 .105.045.116.136.127a2.569 2.569 0 0 1 .506.105 1.4 1.4 0 0 1 .316.191 1.577 1.577 0 0 0 .909.273h6.712a3.057 3.057 0 0 0 .4-.023 1.163 1.163 0 0 0 .824-.476.815.815 0 0 0 .046-1 2.173 2.173 0 0 0-.412-.312.32.32 0 0 1 .114-.123 1.154 1.154 0 0 0 .831-.8.722.722 0 0 0-.228-.829 2.965 2.965 0 0 0-.4-.219.513.513 0 0 1 .159-.153 1.1 1.1 0 0 0 .678-.483.783.783 0 0 0-.357-1.273.155.155 0 0 1-.093-.1.132.132 0 0 1 .114-.148 1.109 1.109 0 0 0 .851-.958.713.713 0 0 0-.389-.822 1.307 1.307 0 0 0-.5-.093h-4.8ZM5.26 7.841c-.057 0-.1-.009-.141-.009H.897a.123.123 0 0 0-.152.153v6.856a.135.135 0 0 0 .166.168h4.166c.178 0 .178 0 .178-.187V7.846Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div
                  class="comment"
                  @click="fetchPost(item.slug)"
                >
                  {{ kFormatter(item.comments_count) }}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15.613"
                    height="13.173"
                    viewBox="0 0 15.613 13.173"
                  >
                    <path
                      d="M11.268 13.173a1.323 1.323 0 0 1-.477-.094 3.582 3.582 0 0 1-.878-.518c-.361-.281-.721-.572-1.07-.854s-.7-.567-1.058-.843a.518.518 0 0 0-.285-.1c-.459-.012-.928-.01-1.382-.009h-.7a5.342 5.342 0 0 1-5.34-4.527 5.336 5.336 0 0 1 .888-3.967 5.228 5.228 0 0 1 3.4-2.2C4.507.035 4.86.014 5.132 0h5.597c.072 0 .141.01.2.016a5.088 5.088 0 0 1 3.188 1.571 5.324 5.324 0 0 1 1.473 3.256 5.36 5.36 0 0 1-3.009 5.378c-.1.051-.1.061-.1.164.015.413.012.83-.009 1.239a2.683 2.683 0 0 1-.135.7 1.22 1.22 0 0 1-.624.748 1.057 1.057 0 0 1-.445.101Zm-4.712-3c.319 0 .64 0 .961.01a1.1 1.1 0 0 1 .615.213h.006c.36.28.721.571 1.069.854s.705.569 1.061.846a3.019 3.019 0 0 0 .732.434.6.6 0 0 0 .467.01.652.652 0 0 0 .316-.4 2.091 2.091 0 0 0 .105-.545c.02-.391.023-.79.009-1.185a.688.688 0 0 1 .419-.71 4.774 4.774 0 0 0 2.69-4.81A4.669 4.669 0 0 0 10.879.6c-.055-.005-.111-.011-.166-.013H5.156c-.408.02-.621.04-.681.051A4.8 4.8 0 0 0 .656 6.129a4.748 4.748 0 0 0 4.769 4.043h1.131Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="canMore"
        class="button-container"
      >
        <ButtonSimple
          :label="
            wallContestsStore.loadingMorePost ? 'Chargement...' : 'Charger plus'
          "
          color="white"
          :outline="true"
          :disabled="wallContestsStore.loadingMorePost"
          @click="loadMorePosts"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { checkLoginModal } from '~/modals/checkLogin'
import type { CustomWallContest } from '~/types'

type RandomWallContestPosts = NonNullable<CustomWallContest['random_posts']>

const props = withDefaults(
  defineProps<{
    posts?: RandomWallContestPosts
    canMore?: boolean
    contestType?: number
    keyIndex?: number
  }>(),
  {
    posts: () => [],
    canMore: false,
    contestType: 0,
    keyIndex: 0,
  },
)

const emit = defineEmits<{
  selectPost: [slug: string]
}>()

const wallContestsStore = useWallContestsStore()
const socialContestsStore = useSocialContestStore()

const currentPage = ref(0)
const route = useRoute()

const loadMorePosts = async () => {
  currentPage.value += 1

  await wallContestsStore.moreWallContestPosts({
    slug: route.params.contestName as string,
    page: currentPage.value,
  })
}

const { gtag } = useGtag()
const fetchPost = (slug?: string) => {
  if (!slug) return

  gtag('event', 'popupPage', {
    popupName: '/popup/media/visualisation',
  })
  emit('selectPost', slug)
}

const { authenticated } = useAuthenticated()

const tryLike = async (post: RandomWallContestPosts[number]) => {
  if (!authenticated.value) {
    return checkLoginModal.open()
  }

  if (post.slug) {
    const toggleLike = post.is_liked ? 'unlikeWcPost' : 'likeWcPost'
    await socialContestsStore[toggleLike](post.slug)
  }

  wallContestsStore.updatePostLike({
    slug: post.slug,
    liked: !post.is_liked,
  })
}

onMounted(async () => {
  await nextTick()
  if (props.contestType !== 2) return
  import('@justinribeiro/lite-youtube')
})
</script>

<style lang="scss">
.contest-grid {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 160px 0 96px;
  overflow: hidden;
  background: #151b27;
  clip-path: polygon(0 50px, 100% 0%, 100% 100%, 0% 100%);

  @media screen and (max-width: 992px) {
    padding: 70px 0 76px;
  }

  .inner-section {
    position: relative;
    width: 100%;
    max-width: 1760px;
    margin: 0 auto;
    padding: 0 2.5rem;

    @media (min-width: 700px) {
      padding: 0 80px;
    }

    h2 {
      color: #fff;
      font-family: SST;
      font-size: 39px;
      font-weight: 400;
      letter-spacing: 0;
      text-align: center;
      text-transform: none;

      @media screen and (max-width: 700px) {
        font-size: 24px;
      }
    }

    .button-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 90px;

      @media screen and (max-width: 1280px) {
        margin-top: 60px;
      }

      @media screen and (max-width: 700px) {
        margin-top: 40px;
      }
    }

    .no-content {
      width: 100%;
      margin-top: 50px;
      color: #fff;
      font-family: SST;
      font-size: 30px;
      font-weight: 400;
      line-height: 1.3;
      letter-spacing: 0;
      text-align: center;

      @media (max-width: 699px) {
        font-size: 20px;
      }

      @media (min-width: 768px) {
        margin-top: 70px;
      }
    }

    .grid {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;
      margin-top: 50px;

      @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        margin-top: 70px;
      }

      @media (min-width: 1400px) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    .item {
      position: relative;
      transition: transform 0.35s ease-in-out;

      &:hover {
        transform: translateY(-4px);
      }

      .content {
        position: relative;
        overflow: hidden;
        border-radius: 30px;

        .img {
          position: relative;
          width: 100%;
          padding-top: 56.25%; // 16x9
          overflow: hidden;
          background-color: rgb(0 0 0 / 0.5);
          cursor: pointer;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .iframe {
          position: relative;
          width: 100%;
          padding-top: 56.25%; // 16x9
          overflow: hidden;

          &-placeholder {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }

          iframe {
            position: absolute;
            top: 0;
            left: 0;
            border: 0;
          }

          .layer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
            cursor: pointer;
          }
        }
      }

      .infos {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 82px;
        padding: 0 20px;
        background: rgb(0 0 0 / 0.7);

        @media screen and (max-width: 1280px) and (min-width: 700px) {
          height: 56px;
        }

        @media screen and (max-width: 700px) {
          height: 46px;
        }

        .waper {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 100%;
          color: #fff;

          .p-waper__avatar {
            flex-shrink: 0;
            width: 42px;
            height: 42px;
            margin-right: 15px;
            overflow: hidden;
            border-radius: 50%;
            object-fit: cover;

            @media screen and (max-width: 1280px) {
              width: 28px;
              height: 28px;
            }

            @media screen and (max-width: 700px) {
              width: 36px;
              height: 36px;
            }
          }

          .p-waper__nickname {
            flex-grow: 1;
            height: 15px;
            overflow: hidden;
            font-family: SST;
            font-size: 10px;
            font-weight: 700;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
          }
        }

        .stats {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 100%;
          color: #fff;

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            margin-left: 30px;
            color: #fff;
            font-family: SST;
            font-size: 11px;
            font-weight: 500;
            cursor: pointer;

            img,
            svg {
              margin-left: 1.4rem;
            }
          }

          .comment {
            svg {
              width: 1.56rem;
              height: 1.317rem;
            }
          }

          .like {
            &.is_liked {
              color: #0072ce;

              svg {
                path {
                  fill: #0072ce;
                }
              }
            }

            svg {
              width: 1.78rem;
              height: 1.57rem;
            }
          }
        }
      }
    }

    .grid-video {
      .item {
        .content {
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }

        .infos {
          position: relative;
          background: #000;
        }
      }
    }
  }
}

// pkg overrides
lite-youtube::before {
  box-sizing: content-box;
}
</style>
